import {
  type TChangelogRelease,
  parseChangelog,
} from '@qmulus/ui/utils/changelog.ts';

let changelogReleasesPromise: Promise<TChangelogRelease[]> | undefined;

/** Loads the changelog on first use, so that it is not part of the bundle every page loads. */
export function loadChangelogReleases(): Promise<TChangelogRelease[]> {
  changelogReleasesPromise ??= import('#/CHANGELOG.md?raw')
    .then((changelogModule) => parseChangelog(changelogModule.default));
  return changelogReleasesPromise;
}
